import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowOutputBlockConfigSchema = z.object({
    data: z.string(),
});
export const FlowOutputBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Output),
    config: FlowOutputBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map